import Index from "../views/chuangyue/Index.vue";
import Find from "../views/chuangyue/Find/Find.vue";
import Login from "../views/chuangyue/Login/Login.vue";
import Register from "../views/chuangyue/Register/Register.vue";
import ForumDetail from "../views/chuangyue/ForumDetail/ForumDetail.vue";

const routes = [
    {
        path: "/index",
        name: "index",
        component: Index,
    },
    {
        path: "/circle/:id",
        name: "circle",
        component: () => import("../views/chuangyue/Index.vue"),
    },
    {
        path: "/demo", // demo
        name: "demo",
        component: () => import("../views/chuangyue/Demo/Demo.vue"),
    },
    {
        path: "/find",
        name: "find",
        component: Find,
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            title: "登录",
        }
    },
    {
        path: "/register",
        name: "register",
        component: () => import("../views/chuangyue/Register/Register.vue"),
        meta: {
            title: "注册",
        }
    },
    {
        path: "/customercenter",
        name: "customercenter",
        component: () =>
            import(
                "../views/chuangyue/CustomerCenter/CustomerCenter.vue"
            ),
    },
    {
        path: "/forget",
        name: "forget",
        component: () => import("../views/chuangyue/Forget/Forget.vue"),
        meta: {
            title: "密码重置",
        }
    },
    {
        path: "/changepassword",
        name: "changepassword",
        component: () =>
            import(
                "../views/chuangyue/ChangePassword/ChangePassword.vue"
            ),
    },
    {
        path: "/editForum/:type/:id/:type_id",
        name: "editForum",
        component: () =>
            import("../views/chuangyue/EditForum/EditForum.vue"),
    },
    {
        path: "/forumdetail/:id",
        name: "forumdetail",
        component: ForumDetail,
    },
    {
        path: "/commentedit/:type/:id",
        name: "commentedit",
        component: () =>
            import("../views/chuangyue/CommentEdit/CommentEdit.vue"),
    },
    {
        path: "/commentlist/:id/:pid",
        name: "commentlist",
        component: () =>
            import("../views/chuangyue/CommentList/CommentList.vue"),
    },
    {
        path: "/iframeorder",
        name: "iframeorder",
        component: () =>
            import("../views/chuangyue/IframeOrder/IframeOrder.vue"),
    },
    {
        path: "/gamelist",
        name: "gamelist",
        component: () => import("../views/chuangyue/GameList/GameList.vue"),
    },
    {
        path: "/gamedetail/:gameid",
        name: "gamedetail",
        component: () =>
            import("../views/chuangyue/GameDetail/GameDetail.vue"),
    },
    {
        path: "/gameupdatalog/:gameid",
        name: "gameupdatalog",
        component: () =>
            import(
                "../views/chuangyue/GameUpdataLog/GameUpdataLog.vue"
            ),
    },
    {
        path: "/welfare",
        name: "welfare",
        component: () => import("../views/chuangyue/Vip/vip.vue"),
    },
    {
        path: "/goodsdetail/:goodsid",
        name: "goodsdetail",
        component: () =>
            import("../views/chuangyue/GoodsDetail/GoodsDetail.vue"),
    },
    {
        path: "/mine",
        name: "mine",
        component: () => import("../views/chuangyue/mine/mine.vue"),
    },
    {
        path: "/userinfo",
        name: "userinfo",
        component: () => import("../views/chuangyue/UserInfo/UserInfo.vue"),
    },
    {
        path: "/treasurechest",
        name: "treasurechest",
        component: () => import("../views/chuangyue/TreasureChest/TreasureChest.vue"),
    },
    {
        path: "/minerecord",
        name: "minerecord",
        component: () => import("../views/chuangyue/MineRecord/MineRecord.vue"),
    },
    {
        path: '/minegame',
        name: 'minegame',
        component: () => import('../views/chuangyue/MineGame/MineGame.vue'),
    },
    {
        path: '/minemember',
        name: 'minemember',
        component: () => import('../views/chuangyue/MineMember/minemember.vue'),
    },
    {
        path: '/minegift',
        name: 'minegift',
        component: () => import('../views/chuangyue/MineGift/MineGift.vue'),
    },
    {
        path: '/address',
        name: 'address',
        component: () => import('../views/chuangyue/Address/Address.vue'),
    },
    {
        path: '/integraldetail',
        name: 'integraldetail',
        component: () => import('../views/chuangyue/IntegralDetail/IntegralDetail.vue'),
    },
    {
        path: '/drafts',
        name: 'drafts',
        component: () => import('../views/chuangyue/Drafts/Drafts.vue'),
    },
    {
        path: '/usersafe',
        name: 'usersafe',
        component: () => import('../views/chuangyue/UserSafe/UserSafe.vue'),
    },
    {
        path: '/paypwd',
        name: 'paypwd',
        component: () => import('../views/chuangyue/PayPwd/PayPwd.vue'),
    },
    {
        path: '/bindingphone',
        name: 'bindingphone',
        component: () => import('../views/chuangyue/BindingPhone/BindingPhone.vue'),
    },
    {
        path: '/realname',
        name: 'realname',
        component: () => import('../views/chuangyue/RealName/RealName.vue'),
        meta: {
            title: "实名认证",
        }
    },
    {
        path: '/switchuser',
        name: 'switchuser',
        component: () => import('../views/chuangyue/SwitchUser/SwitchUser.vue'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/chuangyue/About/About.vue'),
    },
    {
        path: '/agreement/:type',
        name: 'agreement',
        component: () => import('../views/chuangyue/Agreement/Agreement.vue'),
    },
    {
        path: '/message',
        name: 'message',
        component: () => import('../views/chuangyue/Message/Message.vue'),
    },
    {
        path: '/noticedetail/:id',
        name: 'noticedetail',
        component: () => import('../views/chuangyue/NoticeDetail/NoticeDetail.vue'),
    },
    {
        path: '/search/:type',
        name: 'search',
        component: () => import('../views/chuangyue/Search/Search.vue'),
    },
    {
        path: '/complaint/:type/:id',
        name: 'complaint',
        component: () => import('../views/chuangyue/Complaint/Complaint.vue'),
    },
    {
        path: '/uesrdetail',
        name: 'minedetail',
        component: () => import('../views/chuangyue/MineDetail/MineDetail.vue'),
    },
    {
        path: '/attention/:tid',
        name: 'attention',
        component: () => import('../views/chuangyue/Attention/Attention.vue'),
    },
    {
        path: '/mineattention',
        name: 'mineattention',
        component: () => import('../views/chuangyue/MineAttention/MineAttention.vue'),
    },
    {
        path: '/goodsvirtualdetail/:goodsid',
        name: 'goodsvirtualdetail',
        component: () => import('../views/chuangyue/GoodsVirtualDetail/GoodsVirtualDetail.vue'),
    },
    {
        path: '/minecollection',
        name: 'minecollection',
        component: () => import('../views/chuangyue/MineCollection/MineCollection.vue'),
    },
    {
        path: '/headdress',
        name: 'headdress',
        component: () => import('../views/chuangyue/HeadDress/HeadDress.vue'),
    },
    {
        path: '/userdetail',
        name: 'userdetail',
        component: () => import('../views/chuangyue/UserDetail/userdetail.vue'),
    },
    {
        path: '/sign/:forum_id/:is_bind_role',
        name: 'sign',
        component: () => import('../views/chuangyue/Sign/Sign.vue'),
    },
    {
        path: '/',
        name: 'game',
        component: () => import("../views/chuangyue/Game/Game.vue"),
    },
    {
        path: '/iframe-view',
        name: 'iframe-view',
        component: () => import("../views/chuangyue/IFrame/IFrame.vue"),
    },
    //type1为购买，type2为续费
    {
        path: '/cloudPhoneShop/:type',
        name: 'cloudPhoneShop',
        component: () => import('../views/chuangyue/CloudPhoneShop/CloudPhoneShop.vue'),
    },
    {
        path: '/wechatpay/:orderId',
        name: 'wechatpay',
        component: () => import('../views/chuangyue/WechatPay/WechatPay.vue'),
    },
    {
        path: '/getQrCodeInfo',
        name: 'getQrCodeInfo',
        component: () => import('../views/chuangyue/GetQrCodeInfo/GetQrCodeInfo.vue'),
    },
    {
        path: '/h5game',
        name: 'h5game',
        component: () => import('../views/chuangyue/h5game/h5game.vue'),
    },
    {
        path: '/appDownload',
        name: 'appDownload',
        component: () => import('../views/chuangyue/AppDownload/AppDownload.vue'),
    },
    {
        path: '/replyNews',
        name: 'replyNews',
        component: () => import('../views/chuangyue/ReplyNews/ReplyNews.vue'),
    },
    {
        path: '/likesNews',
        name: 'likesNews',
        component: () => import('../views/chuangyue/LikesNews/LikesNews.vue'),
    },
    {
        path: '/officialNewsDetail',
        name: 'officialNewsDetail',
        component: () => import('../views/chuangyue/OfficialNewsDetail/OfficialNewsDetail.vue'),
    },
    {
        path: '/cloudPurchaseList',
        name: 'cloudPurchaseList',
        component: () => import('../views/chuangyue/CloudPurchaseList/CloudPurchaseList.vue'),
    },
    {
        path: '/cloudPhoneManage',
        name: 'cloudPhoneManage',
        component: () => import('../views/chuangyue/CloudPhoneManage/CloudPhoneManage.vue'),
    },
    {
        path: '/superTopic',
        name: 'superTopic',
        component: () => import('../views/chuangyue/SuperTopic/SuperTopic.vue'),
    },
    {
        path: '/moreSuperTopic',
        name: 'moreSuperTopic',
        component: () => import('../views/chuangyue/MoreSuperTopic/MoreSuperTopic.vue'),
    },
    {
        path: '/searchPage',
        name: 'searchPage',
        component: () => import('../views/chuangyue/SearchPage/SearchPage.vue'),
    },
    {
        path: '/moreActivity',
        name: 'moreActivity',
        component: () => import('../views/chuangyue/MoreActivity/MoreActivity.vue'),
    },
    {
        path: '/starDetail',
        name: 'starDetail',
        component: () => import('../views/chuangyue/StarDetail/StarDetail.vue'),
    },
    {
        path: '/receiptInformation',
        name: 'receiptInformation',
        component: () => import('../views/chuangyue/ReceiptInformation/ReceiptInformation.vue'),
    },
    {
        path: '/strategy',
        name: 'strategy',
        component: () => import('../views/chuangyue/Strategy/Strategy.vue'),
    },
    {
        path: '/strategydetail',
        name: 'strategydetail',
        component: () => import('../views/chuangyue/StrategyDetail/StrategyDetail.vue'),
    },
    // sdk页面
    {
        path: '/sdkindex',
        name: 'sdkindex',
        component: () => import('../views/chuangyue/sdk/index/index.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdksetting',
        name: 'sdksetting',
        component: () => import('../views/chuangyue/sdk/setting/setting.vue'),
        meta: {
            title: "设置",
        }
    },
    {
        path: '/sdkchangepassword',
        name: 'sdkchangepassword',
        component: () => import('../views/chuangyue/sdk/changepassword/changepassword.vue'),
        meta: {
            title: "修改密码",
        }
    },
    {
        path: '/sdkfocuswechat',
        name: 'sdkfocuswechat',
        component: () => import('../views/chuangyue/sdk/focuswechat/focuswechat.vue'),
        meta: {
            title: "关注公众号",
        }
    },
    {
        path: '/sdksharegame',
        name: 'sdksharegame',
        component: () => import('../views/chuangyue/sdk/sharegame/sharegame.vue'),
        meta: {
            title: "分享游戏",
        }
    },
    {
        path: '/sdkgift',
        name: 'sdkgift',
        component: () => import('../views/chuangyue/sdk/gift/gift.vue'),
        meta: {
            title: "礼包",
        }
    },
    {
        path: '/sdkrealname',
        name: 'sdkrealname',
        component: () => import('../views/chuangyue/sdk/realname/realname.vue'),
        meta: {
            title: "实名认证",
        }
    },
    {
        path: '/sdkbindphone',
        name: 'sdkbindphone',
        component: () => import('../views/chuangyue/sdk/bindphone/bindphone.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdkresetpassword',
        name: 'sdkresetpassword',
        component: () => import('../views/chuangyue/sdk/resetpassword/resetpassword.vue'),
        meta: {
            title: "重置密码",
        }
    },
    {
        path: '/sdksecurityquestion',
        name: 'sdksecurityquestion',
        component: () => import('../views/chuangyue/sdk/securityquestion/securityquestion.vue'),
        meta: {
            title: "",
        }
    },
    {
        path: '/sdkdeleteaccount',
        name: 'sdkdeleteaccount',
        component: () => import('../views/chuangyue/sdk/deleteaccount/deleteaccount.vue'),
        meta: {
            title: "账号注销",
        }
    },
    {
        path: '/sdkuseragreement',
        name: 'sdkuseragreement',
        component: () => import('../views/chuangyue/sdk/useragreement/useragreement.vue'),
        meta: {
            title: "用户协议",
        }
    },
    {
        path: '/sdkprivacypolicy',
        name: 'sdkprivacypolicy',
        component: () => import('../views/chuangyue/sdk/privacypolicy/privacypolicy.vue'),
        meta: {
            title: "隐私条款",
        }
    },
];

export default routes;
